import { useState } from "react";
import { CalculadoraCDBInputCard } from "./components/pix-parceladoInputCard";
import { PixResponse } from "./utils/pix-parcelado";
import { PixParceladoResponse } from "./components/pix-parceladoResponse";

export default function CalculadoraPixParcelado() {
  const [results, setResults] = useState<PixResponse | null>(null);

  return (
    <>
      <CalculadoraCDBInputCard setResults={setResults} />
      {results && <PixParceladoResponse results={results} />}
    </>
  );
}
